import { Link, useHistory } from 'react-router-dom';
import { Box, Button, MenuItem, Typography } from '@mui/material';
import { Buttons } from '../../../enums/HeaderEnums';
import MenuBarUserProfile from '../../MenuBar/MenuBarUserProfile';
import MenuBarCodebooks from '../../MenuBar/MenuBarCodebooks';
import { StyledLogoDesktop } from '../../../styles/styled/Logo.styled';
import { MenuBarCodebooksEnum } from '../../../enums/MenuBarEnums';

const ROLE_DISPLAY_NAMES = {
  SUPER_ADMIN: 'Super Administrator',
  ADMIN: 'Administrator',
  DRIVER: 'Vozač',
};

const navLinkSx = {
  color: 'white',
  textTransform: 'none',
  fontSize: '0.95rem',
  fontWeight: 400,
  '&:hover': { color: '#7FFF00' },
};

const HeaderDesktop = ({
  isUserAuthenticated,
  handleEdit,
  loggedUser,
  logoutUser,
  showUpdateModal,
  showUpdateUserModal,
  setShowUpdateUserModal,
  user,
}) => {
  const history = useHistory();
  const showHomePage = () => history.push('/');

  const isDriver = loggedUser?.role?.id === 3;
  const isSuperAdmin = loggedUser?.role?.id === 1;
  const isAdmin = loggedUser?.role?.id === 2;
  const roleDisplay = ROLE_DISPLAY_NAMES[loggedUser?.role?.roleName] || '';

  return (
    <>
      {/* Logo + brand name */}
      <Box
        sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', cursor: 'pointer', mr: 3 }}
        onClick={showHomePage}
      >
        <StyledLogoDesktop src={require('../../../assets/images/logo.png')} />
        <Box sx={{ ml: 1 }}>
          <Typography component="span" sx={{ color: 'white', fontWeight: 700, fontSize: '1rem' }}>
            TrackFleet{' '}
          </Typography>
          <Typography component="span" sx={{ color: '#7FFF00', fontWeight: 700, fontSize: '1rem' }}>
            DMS
          </Typography>
        </Box>
      </Box>

      {/* Center nav links */}
      <Box
        sx={{
          flexGrow: 1,
          display: { xs: 'none', md: 'flex' },
          alignItems: 'center',
          justifyContent: 'center',
          gap: 0.5,
        }}
      >
        {isUserAuthenticated && !isDriver && (
          <>
            <Button component={Link} to="/travelOrder" sx={navLinkSx}>
             {MenuBarCodebooksEnum.travelOrder}
            </Button>

            <Button component={Link} to="/vehicle" sx={navLinkSx}>
              {MenuBarCodebooksEnum.vehicle}
            </Button>

            <Button component={Link} to="/userList" sx={navLinkSx}>
             {MenuBarCodebooksEnum.users}
            </Button>
            {!isAdmin && (
              <>
                <Button component={Link} to="/roleList" sx={navLinkSx}>
                  {MenuBarCodebooksEnum.roles}
                </Button>

                <Button component={Link} to="/brand"  sx={navLinkSx}>
                  {MenuBarCodebooksEnum.brand}
                </Button>

                 <Button component={Link} to="/vehicleModel"  sx={navLinkSx}>
                 {MenuBarCodebooksEnum.vehicleModel}
                </Button>
                {/* <Button component={Link} to="/gorivo" sx={navLinkSx}>
                  Gorivo
                </Button>
                <Button component={Link} to="/servisi" sx={navLinkSx}>
                  Servisi
                </Button> */}
                {/* <MenuBarCodebooks loggedUser={loggedUser} /> */}
              </>
            )}
          </>
        )}
      </Box>

      {/* Right — user info + avatar */}
      {isUserAuthenticated ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box sx={{ textAlign: 'right' }}>
            <Typography sx={{ color: 'white', fontWeight: 700, fontSize: '0.9rem', lineHeight: 1.2 }}>
              {loggedUser.firstName}
            </Typography>
            <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.75rem', lineHeight: 1.2 }}>
              {roleDisplay}
            </Typography>
          </Box>
          <MenuBarUserProfile
            logout={logoutUser}
            loggedUser={loggedUser}
            user={user}
            showUpdateModal={showUpdateModal}
            showUpdateUserModal={showUpdateUserModal}
            setShowUpdateUserModal={setShowUpdateUserModal}
            handleEdit={handleEdit}
          />
        </Box>
      ) : (
        <MenuItem key={'loginButton'}>
          <Link to="/login" style={{ color: 'white' }}>{Buttons.signIn}</Link>
        </MenuItem>
      )}
    </>
  );
};

export default HeaderDesktop;
